import { render } from "./PageShow.vue?vue&type=template&id=73520b9a"
import script from "./PageShow.vue?vue&type=script&lang=js"
export * from "./PageShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AfterSales/editTask/components/PageShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73520b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73520b9a', __exports__)) {
    api.reload('73520b9a', __exports__)
  }
  
  module.hot.accept("./PageShow.vue?vue&type=template&id=73520b9a", () => {
    api.rerender('73520b9a', render)
  })

}


export default __exports__